"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosLikeErrorMiddleware = void 0;
class AxiosLikeErrorMiddleware {
    config;
    constructor(config) {
        this.config = config;
    }
    async onRequest(request, next) {
        const response = await next();
        if (response.statusCode >= 200 && response.statusCode < 300) {
            return response;
        }
        const error = new Error(`Request to ${request.url} failed with status code ${response.statusCode}`);
        this.config.handleNotOkStatusCode(error, response);
        const axiosLikeError = {
            response: {
                data: response.body,
                status: response.statusCode,
                statusText: response.statusCode.toString(),
                headers: response.headers ?? {},
                config: {},
            },
            name: "AxiosError",
            message: response.body.message || response.body.error || error,
            isAxiosError: true,
            config: {},
            toJSON: () => {
                return axiosLikeError;
            },
        };
        return Promise.reject(axiosLikeError);
    }
}
exports.AxiosLikeErrorMiddleware = AxiosLikeErrorMiddleware;
//# sourceMappingURL=axios-like-error.middleware.js.map